// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB6MUvzoZ6wGtE-j5TJ2_3WRdaNUT0bMrI",
    authDomain: "funnysnowman-956c7.firebaseapp.com",
    databaseURL: "https://funnysnowman-956c7.firebaseio.com",
    projectId: "funnysnowman-956c7",
    storageBucket: "funnysnowman-956c7.appspot.com",
    messagingSenderId: "509167831389",
    appId: "1:509167831389:web:c78930fd409fafc5"
  },
  SENDGRID_API_KEY:'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'
};

/*
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD2a36RGjEL1f-TyhFtIJIea5461Y9E6d0",
    authDomain: "angular-and-firebase-a0ffe.firebaseapp.com",
    databaseURL: "https://angular-and-firebase-a0ffe.firebaseio.com",
    projectId: "angular-and-firebase",
    storageBucket: "angular-and-firebase.appspot.com",
    messagingSenderId: "37938147387"
  }
} */ 
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
